<template>
    <div :class="alto_contenido()">       
    <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal">
            <div class="seccion_cardsOpciones my-2">
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">                                
                        <router-link :to="{name:'conocenos-manual-de-induccion'}" class="nav-link">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                    <!---Imagen de la card-->
                                    <div class="col-md-4 p-2 text-center justify-content-center" >
                                        <i class="fas fa-book icono_card"></i>
                                    </div>
                                    <!---Texto de la card-->
                                    <div class=" col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Manual de Inducción</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>                                
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">                                
                        <router-link :to="{name:'conocenos-manual-de-organizacion'}" class="nav-link">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-book-open icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body">
                                            <h5 class="card-title titulo_subsec mb-4">Manual de Organización</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>                                
                    </div>          
                </div>
                <div class="row px-1 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-12 col-md-6">                              
                        <router-link :to="{name:'conocenos-manual-de-procedimientos'}" class="nav-link">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-book-reader icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Manual de Procedimientos</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>                                
                    </div>
                   <div class="col-xs-12 col-sm-12 col-md-6">
                        <!--<router-link :to="{name:'tramites-servicios'}" class="nav-link">-->
                            <a href="https://www.chiapas.gob.mx/tram_servicios/uadministrativas.php?id=3178&dependencia=Secretar%C3%ADa%20de%20Hacienda" class="nav-link" target="_blank">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-users icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Manual de Servicios</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </a>
                        <!--</router-link>-->
                    </div> 
                    <!--  <div class="col-xs-12 col-sm-12 col-md-6">
                        <router-link :to="{name:'tramites-servicios'}" class="nav-link">
                            <div class="card mb-3 p-1">
                                <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                        <i class="fas fa-users icono_card"></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                            <h5 class="card-title titulo_subsec mb-4">Manual de Servicios</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div> -->
                </div>
            </div>           
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        alto_contenido(){
            if(screen.width > 1366)  return 'pantalla_grande' 
        }
    }
}
</script>
<style scoped>
.pantalla_grande{  margin-bottom: 14rem !important; }

/* MEDIA QUERY SOLO PARA IPAD 10 pro (MODO HORIZONTAL) */
@media only screen and 
(device-width : 1366px) and 
(device-height : 1024px) and 
(orientation : landscape) {
    .contenido_principal{
        padding-top: 6rem; 
        padding-bottom: 23rem;
    }

} 

</style>